import React from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'

const MDivider = (props) => {
  if (props.data.brand === 'employer-branding' && props.data.layout !== 'umbrella-branding') {
    return <EmployerDivider data={props.data} />
  }

  return <DefaultDivider data={props.data} />
}

const DefaultDivider = (data) => {
  return (
    <Section baseClass="m-SectionDivider" defaultPaddingTop="extra-small" data={data}>
      <div className={`c-Playground ${data.variant ?? ''}`}>
        <div className="c-Playground-graphic"></div>
      </div>
    </Section>
  )
}

const EmployerDivider = (data) => {
  return (
    <Section baseClass="m-SectionDivider" defaultPaddingTop="small" defaultPaddingBottom="small" data={data}>
      <div className="c-Playground c-Playground--fussballmacherIn">
        <div className="c-Playground-wrapper">
          <div className="c-Playground-textItem c-Playground-textItem--lightGreen">HIER</div>
          <div className="c-Playground-textItem c-Playground-textItem--darkerGreen">WIRST DU</div>
          <div className="c-Playground-imgItem c-Playground-imgItem--dfbLogo"></div>
          <div className="c-Playground-textItem c-Playground-textItem--accentGreen">#FUSSBALLMACHER*IN</div>
          <div className="c-Playground-imgItem c-Playground-imgItem--muscle"></div>
        </div>
      </div>
    </Section>
  )
}

export default MDivider
